// Mobile Add to Cart Test Script
// This script helps debug mobile add to cart issues

document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile devices
  if (window.innerWidth > 989) return;
  
  console.log('Mobile Add to Cart Test Script Loaded');
  
  // Find all add to cart buttons
  const addToCartButtons = document.querySelectorAll('[name="add"]');
  console.log('Found add to cart buttons:', addToCartButtons.length);
  
  addToCartButtons.forEach((button, index) => {
    console.log(`Button ${index + 1}:`, {
      disabled: button.disabled,
      ariaDisabled: button.getAttribute('aria-disabled'),
      pointerEvents: getComputedStyle(button).pointerEvents,
      zIndex: getComputedStyle(button).zIndex,
      touchAction: getComputedStyle(button).touchAction
    });
    
    // Add test event listeners
    button.addEventListener('touchstart', function(e) {
      console.log('Touch start on add to cart button');
    });
    
    button.addEventListener('touchend', function(e) {
      console.log('Touch end on add to cart button');
    });
    
    button.addEventListener('click', function(e) {
      console.log('Click event on add to cart button');
    });
    
    // Test form submission
    const form = button.closest('form');
    if (form) {
      form.addEventListener('submit', function(e) {
        console.log('Form submit event triggered');
      });
    }
  });
  
  // Check for product form custom element
  const productForm = document.querySelector('product-form');
  if (productForm) {
    console.log('Product form custom element found');
  } else {
    console.log('Product form custom element NOT found');
  }
  
  // Check for any overlapping elements
  function checkForOverlappingElements() {
    addToCartButtons.forEach((button, index) => {
      const rect = button.getBoundingClientRect();
      const elementAtPoint = document.elementFromPoint(
        rect.left + rect.width / 2,
        rect.top + rect.height / 2
      );
      
      if (elementAtPoint !== button) {
        console.warn(`Button ${index + 1} is covered by:`, elementAtPoint);
      }
    });
  }
  
  // Run overlap check after a delay to ensure page is fully loaded
  setTimeout(checkForOverlappingElements, 1000);
});
